import { generateBlogTitleswithLabels, getComplementaryItems } from '../../util/api';
import { slugToNormalString } from '../../util/dates';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const GENERATE_BLOG_TITLES_REQUEST = 'app/PublishedListingPage/GENERATE_BLOG_TITLES_REQUEST';
export const GENERATE_BLOG_TITLES_SUCCESS = 'app/PublishedListingPage/GENERATE_BLOG_TITLES_SUCCESS';
export const GENERATE_BLOG_TITLES_ERROR = 'app/PublishedListingPage/GENERATE_BLOG_TITLES_ERROR';

export const FETCH_LISTING_REQUEST = 'app/PublishedListingPage/FETCH_LISTING_REQUEST';
export const FETCH_LISTING_SUCCESS = 'app/PublishedListingPage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/PublishedListingPage/FETCH_LISTING_ERROR';

export const FETCH_COMPLEMENTARY_ITEMS_REQUEST = 'app/PublishedListingPage/FETCH_COMPLEMENTARY_ITEMS_REQUEST';
export const FETCH_COMPLEMENTARY_ITEMS_SUCCESS = 'app/PublishedListingPage/FETCH_COMPLEMENTARY_ITEMS_SUCCESS';
export const FETCH_COMPLEMENTARY_ITEMS_ERROR = 'app/PublishedListingPage/FETCH_COMPLEMENTARY_ITEMS_ERROR';


// ================ Reducer ================ //

const initialState = {
    blogTitleswithLabels: [],
    blogTitleswithLabelsError: null,
    blogTitleswithLabelsInProgress: null,
    listing: null,
    fetchListingInProgress: false,
    fetchListingError: null,
    complementaryItems: [],
    complementaryItemsInProgress: false,
    complementaryItemsError: null,
};

// ================ Reducer ================ //

const publishedListingPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERATE_BLOG_TITLES_REQUEST:
            return { ...state, blogTitleswithLabelsInProgress: true };
        case GENERATE_BLOG_TITLES_SUCCESS:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabels: action.payload };
        case GENERATE_BLOG_TITLES_ERROR:
            return { ...state, blogTitleswithLabelsInProgress: false, blogTitleswithLabelsError: action.payload };
        case FETCH_LISTING_REQUEST:
            return { ...state, fetchListingInProgress: true, fetchListingError: null };
        case FETCH_LISTING_SUCCESS:
            return { ...state, fetchListingInProgress: false, listing: action.payload.listing };
        case FETCH_LISTING_ERROR:
            return { ...state, fetchListingInProgress: false, fetchListingError: action.payload };
        case FETCH_COMPLEMENTARY_ITEMS_REQUEST:
            return { ...state, complementaryItemsInProgress: true, complementaryItemsError: null };
        case FETCH_COMPLEMENTARY_ITEMS_SUCCESS:
            return { ...state, complementaryItemsInProgress: false, complementaryItems: action.payload };
        case FETCH_COMPLEMENTARY_ITEMS_ERROR:
            return { ...state, complementaryItemsInProgress: false, complementaryItemsError: action.payload };
        default:
            return state;
    }
};

export default publishedListingPageReducer;

// ================ Action creators ================ //
export const fetchComplementaryItemsRequest = () => ({
    type: FETCH_COMPLEMENTARY_ITEMS_REQUEST,
});
export const fetchComplementaryItemsSuccess = items => ({
    type: FETCH_COMPLEMENTARY_ITEMS_SUCCESS,
    payload: items,
});
export const fetchComplementaryItemsError = error => ({
    type: FETCH_COMPLEMENTARY_ITEMS_ERROR,
    payload: error,
});

export const generateBlogTitlesRequest = () => ({
    type: GENERATE_BLOG_TITLES_REQUEST,
});

export const generateBlogTitlesSuccess = (blogTitleswithLabels) => ({
    type: GENERATE_BLOG_TITLES_SUCCESS,
    payload: blogTitleswithLabels,
});

export const generateBlogTitlesError = (error) => ({
    type: GENERATE_BLOG_TITLES_ERROR,
    payload: error,
});

export const fetchListingRequest = (listingId) => ({
    type: FETCH_LISTING_REQUEST,
    payload: { listingId },
});

export const fetchListingSuccess = ({ listing }) => ({
    type: FETCH_LISTING_SUCCESS,
    payload: { listing },
});

export const fetchListingError = (error) => ({
    type: FETCH_LISTING_ERROR,
    payload: error,
});

// ================ Thunks ================ //

export const fetchComplementaryItems = ({ title, category, description, location }) => (dispatch, getState, sdk) => {
    dispatch(fetchComplementaryItemsRequest());
    return getComplementaryItems({ title, category, description, location })
        .then(({ data }) => {
            dispatch(fetchComplementaryItemsSuccess(data.complementaryItems || []));
            return data.complementaryItems || [];
        })
        .catch((error) => dispatch(fetchComplementaryItemsError(error)));
};

export const fetchBlogTitleswithLabels = (slug) => (dispatch, getState, sdk) => {
    dispatch(generateBlogTitlesRequest());
    const listingTitle = slugToNormalString(slug);
    
    return generateBlogTitleswithLabels({ listingTitle, isCallbackFn: false })
        .then(({ data }) => {
            const { blogTitles } = data;
            dispatch(generateBlogTitlesSuccess(blogTitles));
            return blogTitles;
        })
        .catch(error => dispatch(generateBlogTitlesError(error)));
};

export const fetchListing = (listingId) => (dispatch, getState, sdk) => {
    dispatch(fetchListingRequest(listingId));
    const params = {
      id: listingId
    };
    const show = sdk.listings.show(params);
    return show
      .then(data => {
        const listing = data.data.data;
        dispatch(fetchListingSuccess({ listing }));
        return listing;
      })
      .catch(e => {
        dispatch(fetchListingError(storableError(e)));
      });
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
    const { listingId: id, slug } = params || {};
    // First, fetch the listing, then use its data for complementary items
    return dispatch(fetchListing(id)).then((listing) => {
        const { title, description, price, publicData } = listing.attributes;
        const { category, location } = publicData;
        const { address } = location || {};
        const currency = price.currency;  
        
        return Promise.all([
            dispatch(fetchBlogTitleswithLabels(slug)),
            dispatch(fetchComplementaryItems({
                title,
                category,
                description,
                location: address,
                currency,
            })),
        ]);
    });
};
